import { Zap } from 'lucide-react';
import { type GameConfig } from '../../data/games';

export default function HomeGameCard({ game, onClick, completed, compact = false }: {
  game: GameConfig;
  onClick: () => void;
  completed: boolean;
  compact?: boolean;
}) {
  return (
    <button onClick={onClick} className="cyber-game" title={compact ? game.description : undefined}>
      <b>{game.name}{completed && <span className="cyber-completed" aria-label="已完成"> ✓</span>}</b>
      {compact ? <i>{game.category}</i> : <>
        <i>{game.description}</i>
        <span className="cyber-game-meta">
          <span>{'⭐'.repeat(game.difficulty)}</span>
          {game.unlockEnergy > 0 && <span><Zap size={10} />{game.unlockEnergy}</span>}
        </span>
        <i>建议训练 {Math.max(1, Math.round((game.params?.duration ?? (game.difficulty === 1 ? 30 : game.difficulty === 2 ? 40 : 55)) / 60))} 分钟 · 目标{game.difficulty === 1 ? '≥60分' : game.difficulty === 2 ? '≥75分' : '≥85分'}</i>
      </>}
    </button>
  );
}
